import { euroFormatterIt } from 'app/src/shared/helpers'
import { Button } from 'primereact/button'
import { useEffect, useState, type ReactElement } from 'react'

export type MultiVoucherItemType<T> = {
  id: string | number
  label: string
  unitPrice?: number
  quantity: number
  active: boolean
  payload?: T
}
export type CounterPricePropsType<T> = {
  callbackOnChangeQuantity: (item: MultiVoucherItemType<T>) => void
  item: MultiVoucherItemType<T>
  isLast: boolean
  upperBound?: number
}
export function CounterPrice<T>(props: CounterPricePropsType<T>): ReactElement {
  const [quantity, setQuantity] = useState<number>(props.item?.quantity ?? 0)
  useEffect(() => {
    props.callbackOnChangeQuantity({ ...props.item, quantity })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  return (
    <div
      className={`col-span-12 mt-1 flex max-w-[500px] flex-row items-center justify-between bg-[var(--card-background)] p-[20px]`}
      style={{ width: '-webkit-fill-available' }}
    >
      <div className='flex min-w-[30%] flex-1 justify-start text-[14px] font-normal'>{props.item.label}</div>
      <div className='flex min-w-[95px] flex-row items-center justify-center'>
        <Button
          data-testid={`counter-price-decrease-${props.item.id}`}
          outlined
          // className='custom-btn-disabled h-[32px] w-[24px] px-[4px] hover:bg-[#F6F6F6]'
          className='h-[28px] w-[36px] px-[4px]'
          disabled={!props.item?.active || quantity === 0}
          icon='pi pi-minus'
          onClick={() => setQuantity((x) => x - 1)}
        />
        <p style={{ minWidth: 30, textAlign: 'center', margin: 0 }}> {quantity} </p>
        <Button
          data-testid={`counter-price-increase-${props.item.id}`}
          className='h-[28px] w-[36px] px-[4px]'
          disabled={!props.item?.active || (typeof props.upperBound !== 'undefined' && quantity >= props.upperBound)}
          icon='pi pi-plus'
          onClick={() => setQuantity((x) => x + 1)}
        />
      </div>
      <div className='flex min-w-[33%] flex-row items-center justify-end text-[14px]'>
        <b>{euroFormatterIt.format((props.item?.unitPrice ?? 0) * quantity)}</b>
      </div>
    </div>
  )
}
